import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

// ICONS
import { BiMouse } from 'react-icons/bi';

// VARIANTS
const banner = {
  animate: {
    transition: {
      delayChildren: 0.4,
      staggerChildren: 0.1,
    },
  },
};

const letterAnimation = {
  initial: {
    y: 400,
  },
  animate: {
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1,
    },
  },
};

const Banner = () => {
  const [playMarquee, setPlayMarquee] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setPlayMarquee(true);
    }, 2000);
  }, []);
  return (
    <motion.div variants={banner} className="banner">
      <BannerRowTop greet={'Hello! I am'} fullname={'Aryan Bhandari'} />
      <BannerRowCenter
        title={'Mentor.Developer.Coder.'}
        playMarquee={playMarquee}
      />
      <BannerRowBottom />
    </motion.div>
  );
};

const AnimatedLetters = ({ title, disabled }) => (
  <motion.span
    className="row-title"
    variants={disabled ? null : banner}
    initial="initial"
    animate="animate"
  >
    {[...title].map((letter, i) => (
      <motion.span
        key={i}
        className="row-letter"
        variants={disabled ? null : letterAnimation}
      >
        {letter}
      </motion.span>
    ))}
  </motion.span>
);
const AnimatedTop = ({ title }) => (
  <motion.span
    className="row-title-custom"
    variants={banner}
    initial="initial"
    animate="animate"
  >
    {[...title].map((letter, i) => (
      <motion.span key={i} className="row-custom" variants={letterAnimation}>
        {letter}
      </motion.span>
    ))}
  </motion.span>
);

const BannerRowTop = ({ greet, fullname }) => {
  return (
    <div className={'banner-row'}>
      <div className="hero-intro">
        <motion.span
          className="greet"
          variants={banner}
          initial="initial"
          animate="animate"
        >
          <motion.span variants={letterAnimation}>{greet}</motion.span>
        </motion.span>
        <motion.span
          className="fullname"
          variants={banner}
          initial="initial"
          animate="animate"
        >
          <span id="animatedTop1">
            <AnimatedTop title={'Aryan'} />
          </span>
          <span id="animatedTop2">
            <AnimatedTop title={'Bhandari'} />
          </span>
        </motion.span>
      </div>
    </div>
  );
};

const BannerRowCenter = ({ title, playMarquee }) => {
  return (
    <div className="marquee_outer">
      <div className={`banner-row marquee  ${playMarquee && 'animate'}`}>
        <div className="marquee__inner">
          <AnimatedLetters title={title} />
          <AnimatedLetters title={title} />
          <AnimatedLetters title={title} />
        </div>
      </div>
    </div>
  );
};

const BannerRowBottom = ({ title }) => {
  return (
    <div className={'banner-row center'}>
      <motion.div
        className="scroll"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1 }}
      >
        <motion.span
          className="explore"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            delay: 1.8,
          }}
        >
          Explore
        </motion.span>
        <motion.span
          initial={{ y: 0 }}
          animate={{ y: 15 }}
          transition={{
            repeat: Infinity,
            repeatType: 'reverse',
            duration: 0.8,
          }}
        >
          <BiMouse />
        </motion.span>
      </motion.div>
    </div>
  );
};

export default Banner;
